import { ENCRYPTION_SECRET_KEY } from "common/constants/sm-constants";
import CryptoJS from "crypto-js";

export class EncryptionAndDecryption {
    public static encryption(body: any): any {
        let iv = CryptoJS.enc.Hex.parse("SiemensScholarShipProgramSSP123456")
        return CryptoJS.AES.encrypt(JSON.stringify(body), ENCRYPTION_SECRET_KEY, { mode: CryptoJS.mode.CTR, iv: iv }).toString();
    }

    public static decryption(body: any) {
        try {
            let iv = CryptoJS.enc.Hex.parse("SiemensScholarShipProgramSSP123456")
            const bytes = CryptoJS.AES.decrypt(body, ENCRYPTION_SECRET_KEY, { mode: CryptoJS.mode.CTR, iv: iv });
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } catch (err) {
            return body;
        }
    }

}